import { render } from "./choice-exam.vue?vue&type=template&id=32c1ee81&scoped=true"
import script from "./choice-exam.vue?vue&type=script&lang=js"
export * from "./choice-exam.vue?vue&type=script&lang=js"

import "./choice-exam.vue?vue&type=style&index=0&id=32c1ee81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c1ee81"]])

export default __exports__